module.exports = __webpack_public_path__ + "assets/img/05191bc88c7957ad2e922499c977c6fc.png";